import Facebook from './facebook';
import Instagram from './instagram';
import Twitter from './twitter';
import Snapchat from './snapchat';
import Pinterest from './pinterest';

export default {
    facebook: Facebook,
    instagram: Instagram,
    twitter: Twitter,
    snapchat: Snapchat,
    pinterest: Pinterest
};



// WEBPACK FOOTER //
// ./campaign_analytics/v2/campaign_analytics_page/posts/ad_mode/submission_ctas/index.js